import { searchIndexData } from './searchIndex.data';
import { SearchItem } from '@/types/search.types';

const POPULAR_IDS = [
  'charter',
  'citation-x',
  'hera-10-hour-s-jet-program',
  'empty-leg-flights',
  'available-fleet',
];

export const popularSearches: SearchItem[] = POPULAR_IDS.map((id) =>
  searchIndexData.find((item) => item.id === id)
).filter((item): item is SearchItem => item !== undefined);
